import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useDrawer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadOne } from 'src/mtska-frontend-data-provider/hooks/useLoadOne.hooks';

const dataProviderName = 'renters/installed';
const wizardName = 'Apply action';
const wizardAction = 'applyAction';
const wizardObject = 'Installed';


const ApplyAction = (params) => {
    const { t } = useTranslation();
    const { userCapabilities, existingModules } = useContext(AppContext);

    // DATA PROVIDER
    const {
        item,
        loadOne,
        errorMessage,
        errors,
        saving,
        doAction,
        reloadCounter,
        getOne,
    } = useDataProvider(dataProviderName, params.multipart);


    const [availableActions, setAvailableActions] = useState([]);
    useEffect(() => {
        if (params.items && params.items.length > 0) {

            const actions = params.items.reduce((acc, itemId) => {
                const car = getOne(itemId);
                if (car.synchronizer) {
                    const carActions = car.synchronizer.actions.actions.split(',');
                    carActions.forEach(action => {
                        if (!acc.includes(action)) {
                            acc.push(action);
                        }
                    });
                }
                return acc;
            }, []);

            setAvailableActions(actions);
        }
    }, [params.items]);




    const modelName = existingModules.modelName

    const detailConfig = {
        "tabs": [
            {
                "name": "actions",
                "fieldsets": [
                    {
                        "name": "actions",
                        "fields": {
                            "action": {
                                "type": "select",
                                "options": availableActions.map(itm => {
                                    return {
                                        label: itm,
                                        value: itm
                                    }
                                }),
                                "required": true,
                                "className": "col-12"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const handleSave = (data) => {
        doAction({
            action: wizardAction,
            model: dataProviderName,
            model_ids: params.items,
            data: { ...data, model_ids: params.items }
        }).then((data) => {
            params.handleClose(params.uid, data.item.data)
        }).catch(() => console.error('catch handleSave'));
    }


    return <>
        {/* {params.items.map((item)=>   <>{JSON.stringify(getOne(item))}</>)} */}
        <DetailComponent
            values={{}}
            modelName={modelName}
            detailConfig={detailConfig}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={true}
            // canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t(
                        'Apply action to {{total}} {{wizardObject}}',
                        {
                            wizardObject: wizardObject,
                            total: params.items.length,
                        }
                    )}
                />
            }
            {...params}
        />
    </>
}

export default ApplyAction;


